import { render, staticRenderFns } from "./ClinicResponsibleClinicsModal.vue?vue&type=template&id=937bf8ac"
import script from "./ClinicResponsibleClinicsModal.vue?vue&type=script&lang=js"
export * from "./ClinicResponsibleClinicsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports